/**
 * Automatic crossfading slideshow behind the page hero (sections/page-hero.liquid).
 * Slides are stacked; the active one gets .is-active (opacity transition lives in CSS). Advances every
 * data-interval seconds, pauses while the tab is hidden, and stays on the first slide when the visitor
 * prefers reduced motion. In the theme editor it jumps to a slide when its block is selected.
 */
class PageHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.page-hero__slide')];
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    if (this.slides.length < 2) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    this.onBlockSelect = (event) => {
      const slide = event.target.closest?.('.page-hero__slide');
      const target = this.slides.indexOf(slide);
      if (target >= 0) {
        this.show(target);
        this.stop();
      }
    };
    document.addEventListener('visibilitychange', this.onVisibility);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    document.addEventListener('shopify:block:deselect', () => this.start());
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  get interval() {
    return (parseInt(this.dataset.interval, 10) || 6) * 1000;
  }

  start() {
    this.stop();
    if (this.reduceMotion.matches) return;
    this.timer = setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  show(next) {
    const target = (next + this.slides.length) % this.slides.length;
    this.slides[this.index].classList.remove('is-active');
    this.slides[target].classList.add('is-active');
    this.index = target;
  }
}
customElements.define('page-hero-slideshow', PageHeroSlideshow);
